import client from '@/api/client';
import { BASE_URL } from '@/constants';
import { objectToQueryString } from '@/utils/sfaas_temp';

export default {
	async getCommCodes(codeType, plantCd) {
		try {
			const response = await client.get(`${BASE_URL}/cc/v1/plants/${plantCd}/commonCodes?commCdType=${codeType}`);
			return response?.data || null;
		} catch (error) {
			throw error.response?.data;
		}
	},
	/**한번에 공통 코드 부르기 */
	async getCommCodesOnce() {
		try {
			const response = await client.get(`${BASE_URL}/comm/common/custCode/v1/mmcCustCodeLists`);
			return response?.data;
		} catch (error) {
			throw error.response?.data;
		}
	},
	/** 교정업체 셀렉트 정보 조회 */
	async getMmcInstList() {
		try {
			const response = await client.get(`${BASE_URL}/mmc/mmcm/mesCal/v1/mmcInsts`);
			return response?.data;
		} catch (error) {
			throw error.response?.data;
		}
	},
	async getMesList({ searchParams, pagingInfo }) {
		const queryStr = objectToQueryString({
			mesEqipNo: searchParams.mesEqipNo?.trim(),
			mesEqipNm: searchParams.mesEqipNm?.trim(),
			calStCd: searchParams.calStCd, //교정상태
			runStCd: searchParams.runStCd, //가동상태
			user1Id: searchParams.userId,
			user1Nm: !searchParams.userId ? searchParams.userName?.trim() : '',
			useDeptCd: searchParams.useDeptCd ? searchParams.useDeptCd : searchParams.userDeptNm?.trim(),
			strDt: searchParams.strDt,
			endDt: searchParams.endDt,
			currentPage: pagingInfo.currentPage,
			pageUnit: pagingInfo.pageUnit
		});
		try {
			const response = await client.get(`${BASE_URL}/mmc/mmcm/mesInfm/v1/infms${queryStr}`);
			return response?.data || null;
		} catch (error) {
			throw error.response?.data;
		}
	},
	async getHistoryList(params, emlPagingInfo) {
		const queryStr = objectToQueryString({
			mesEqipNo: params.mesEqipNo?.trim(),
			strDt: params.strDt,
			endDt: params.endDt,
			currentPage: emlPagingInfo.currentPage,
			pageUnit: emlPagingInfo.pageUnit
		});
		try {
			const response = await client.get(`${BASE_URL}/mmc/mmcm/mesInfm/v1/emls${queryStr}`);
			return response?.data;
		} catch (error) {
			throw error.response?.data;
		}
	},
	async sendEmail(data) {
		try {
			const response = await client.post(`${BASE_URL}/mmc/mmcm/mesInfm/v1/status/1/mail`, data);
			return response?.data;
		} catch (error) {
			throw error.response?.data;
		}
	},
	async alreadyInfm(data) {
		try {
			const response = await client.post(`${BASE_URL}/mmc/mmcm/mesInfm/v1/status/2/infm`, data);
			return response?.data;
		} catch (error) {
			throw error.response?.data;
		}
	},
	async saveWhsn(data) {
		try {
			const response = await client.post(`${BASE_URL}/mmc/mmcm/mesInfm/v1/status/2/whsn`, data);
			return response?.data;
		} catch (error) {
			throw error.response?.data;
		}
	},
	async fileDownload(params) {
		// 이미지 미리보기와 실제파일 다운로드에서 같이 사용하기 때문에 주의할것
		try {
			const response = await client.post(`${BASE_URL}/uploadForm/v1/downloadFile`, params, { responseType: 'blob' });
			return response;
		} catch (error) {
			throw error.response?.data;
		}
	}
};
